import { render, staticRenderFns } from "./TangkapDpo.vue?vue&type=template&id=faad01ee&"
import script from "./TangkapDpo.vue?vue&type=script&lang=js&"
export * from "./TangkapDpo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports